export default {
    lang: {
        name: 'Games'
    }
}